import { render, staticRenderFns } from "./AddProductReport.vue?vue&type=template&id=18bce797&scoped=true&"
import script from "./AddProductReport.vue?vue&type=script&lang=js&"
export * from "./AddProductReport.vue?vue&type=script&lang=js&"
import style0 from "./AddProductReport.vue?vue&type=style&index=0&id=18bce797&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bce797",
  null
  
)

component.options.__file = "AddProductReport.vue"
export default component.exports